import React from "react";
import { Menu } from "lucide-react";
import { useSelector } from "react-redux";
import { Button } from "../ui/button";
import { Badge } from "../ui/badge";
import { ThemeToggle } from "../theme-toggle";
import GlobalSearch from "./GlobalSearch";

function Header({ onMenuClick }) {
  const authUser = useSelector((state) => state.auth.user);
  const isSuperAdmin = authUser?.role === "super_admin";

  return (
    <header className="sticky top-0 z-30 flex h-16 items-center gap-4 border-b border-border bg-background px-6">
      <Button
        variant="ghost"
        size="icon"
        className="lg:hidden"
        onClick={onMenuClick}
      >
        <Menu className="h-5 w-5" />
      </Button>

      <GlobalSearch />

      <div className="flex items-center gap-2">
        {isSuperAdmin && (
          <Badge variant="secondary" className="hidden sm:inline-flex">
            Super admin
          </Badge>
        )}
        <ThemeToggle />
      </div>
    </header>
  );
}

export default Header;
